import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('Email harus diisi');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${API}/auth/forgot-password`, {
                email: email
            });

            if (response.data) {
                toast.success(response.data.message || 'Email verifikasi telah dikirim');
                // Navigate to reset password page or back to login
                navigate('/login', { 
                    state: { 
                        message: 'Cek email Anda untuk link reset password' 
                    } 
                });
            }
        } catch (error) {
            console.error('Error sending forgot password email:', error);
            
            const errorData = error.response?.data?.detail;
            
            // Check if error is EMAIL_NOT_VERIFIED
            if (typeof errorData === 'object' && errorData?.code === 'EMAIL_NOT_VERIFIED') {
                toast('Email belum diverifikasi. Silakan verifikasi email terlebih dahulu.');
                // Redirect to verify email page
                navigate('/verify-email', { state: { email: errorData.email } });
                return;
            }
            
            // Safely extract error message
            let errorMessage = 'Terjadi kesalahan. Silakan coba lagi.';
            if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                } else if (error.response.data.detail) {
                    if (typeof error.response.data.detail === 'string') {
                        errorMessage = error.response.data.detail;
                    } else if (error.response.data.detail.message) {
                        errorMessage = error.response.data.detail.message;
                    }
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }
            
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-ltb-br flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-md">
                <div className="text-center mb-6 sm:mb-8">
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">Lupa Password</h1>
                    <p className="text-sm sm:text-base text-gray-600">Masukkan email Anda untuk mereset password</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Email <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ltb-bright focus:border-transparent"
                            placeholder="email@example.com"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-ltb-bright hover:bg-ltb-medium text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Mengirim...' : 'Kirim Email Verifikasi'}
                    </button>
                </form>

                <div className="mt-4 sm:mt-6 text-center space-y-2">
                    <p className="text-sm sm:text-base text-gray-600">
                        Ingat password Anda?{' '}
                        <button
                            onClick={() => navigate('/login')}
                            className="text-ltb-bright hover:text-ltb-medium font-semibold"
                        >
                            Login
                        </button>
                    </p>
                    <p className="text-sm sm:text-base text-gray-600">
                        Belum punya akun?{' '}
                        <button
                            onClick={() => navigate('/register')}
                            className="text-ltb-bright hover:text-ltb-medium font-semibold"
                        >
                            Daftar
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;